export default {
  topic: 'Meeting title',
} as const;
